// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import './assets/css/common.css'
import * as echarts from 'echarts'
import CsRuler from 'cs-ruler'//刻度尺组件
import BaiduMap from 'vue-baidu-map'
import store from './store'
import api from './api/index.js';
import axios from 'axios'
import ba from 'vue-ba'

Vue.use(ba, {siteId: '14a7013617926814bf0c4fa3fd4baa2a'})

Vue.use(api);
Vue.use(CsRuler)
Vue.use(BaiduMap, {
    ak: 'SFLriwDFDZHv8ZvcI76ObkhrXL0cOqHe'
})
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios


Vue.use(ElementUI, {locale})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireAuth)) {  // 判断该路由是否需要登录权限
        console.log('需要登录');
        if (localStorage.getItem('bdwatch_training')) {  // 判断当前的token是否存在 ； 登录存入的token
            next();
        } else {
            next({
                path: '/',
                query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    } else {
        next();
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    axios,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js